import { j as i } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = s(
  (r, l) => /* @__PURE__ */ i.jsx(
    t,
    {
      ref: l,
      ...r,
      image: (o) => /* @__PURE__ */ i.jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...o,
          children: [
            /* @__PURE__ */ i.jsx("g", { clipPath: "url(#clip0_3410_69092)", children: /* @__PURE__ */ i.jsx(
              "path",
              {
                fill: "currentColor",
                d: "M8 16a6 6 0 0 0 6-6 6.52 6.52 0 0 0-1.512-4.177L8.768 1.36a1 1 0 0 0-1.536 0l-3.72 4.463A6.52 6.52 0 0 0 2 10a6 6 0 0 0 6 6"
              }
            ) }),
            /* @__PURE__ */ i.jsx("defs", { children: /* @__PURE__ */ i.jsx("clipPath", { id: "clip0_3410_69092", children: /* @__PURE__ */ i.jsx("path", { fill: "#fff", d: "M16 16H0V0h16z" }) }) })
          ]
        }
      )
    }
  )
);
a.displayName = "DropIcon";
export {
  a as DropIcon,
  a as default
};
//# sourceMappingURL=index.js.map
